"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderConfirmationRo = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.OrderConfirmationRo = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    delivery_date: typebox_1.Type.String(),
    delivery_instructions: typebox_1.Type.String(),
    material: typebox_1.Type.String(),
    dumpster_size: typebox_1.Type.String(),
    weight_limit: typebox_1.Type.String(),
    rental_period: typebox_1.Type.String(),
    rental_extension_fee: typebox_1.Type.String(),
    order_total: typebox_1.Type.String(),
    csa_name: typebox_1.Type.String(),
    prohibited_items_string: typebox_1.Type.String(),
    overage_fee: typebox_1.Type.String(),
    custom_message: typebox_1.Type.String(),
    pickup_date: typebox_1.Type.String(),
    payment_link: typebox_1.Type.String(),
    order_number: typebox_1.Type.String(),
});
//# sourceMappingURL=order-confirmation-ro.js.map